import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'

export const SecondaryText = ({ text, sx }) => {
   const CustomLightText = styled(Typography)(() => (({
    color: customStyles.colors.textColor,
   //  textAlign: 'center'
   ...sx
   })))
  return (
    <CustomLightText component="p">{ text }</CustomLightText>
  )
}
